module.exports = __webpack_public_path__ + "img/044.e8ba15e5.jpg";